import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = {
  key: 0,
  class: "ion-text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "ion-text-center"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "event-badges" }
const _hoisted_6 = {
  key: 0,
  class: "event-paid"
}
const _hoisted_7 = {
  key: 1,
  class: "event-soldout"
}
const _hoisted_8 = {
  key: 2,
  class: "event-count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: _normalizeClass(["ion-no-border events-page-header", { 'page-header--scrolled': _ctx.headerScrolled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.openMenu }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.menuOutline }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("События", -1)
                ]))]),
                _: 1
              }),
              (_ctx.isAdmin)
                ? (_openBlock(), _createBlock(_component_ion_buttons, {
                    key: 0,
                    slot: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/admin-events')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.createOutline }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_content, {
        class: "main-background events-content",
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.load($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Загрузка..."))
              : (_ctx.events.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Нет предстоящих событий."))
                : (_openBlock(), _createBlock(_component_ion_list, {
                    key: 2,
                    lines: "full"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (ev) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: ev.id,
                          button: "",
                          onClick: ($event: any) => (_ctx.$router.push(`/events/${ev.id}`)),
                          class: "event-item"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: ev.logoPath ? _ctx.eventsService.logoUrl(ev.logoPath) : _ctx.defaultEventLogo,
                              slot: "start",
                              class: "event-logo",
                              alt: ev.title
                            }, null, 8, _hoisted_4),
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("h2", null, _toDisplayString(ev.title), 1),
                                _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(ev.startAt)) + " · " + _toDisplayString(ev.location || 'Место уточняется'), 1),
                                _createElementVNode("p", _hoisted_5, [
                                  (ev.isPaid)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Платное"))
                                    : _createCommentVNode("", true),
                                  (_ctx.isSoldOut(ev))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Sold out"))
                                    : _createCommentVNode("", true),
                                  (_ctx.registrationsBadge(ev))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.registrationsBadge(ev)), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
          ])
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}